import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import Dashboard from '../Dashboard'
import { selectUserData } from '../../reducers/userDataReducer'
import './customer-portal.scss'

const CustomerPortal = () => {
  const { t } = useTranslation(['customer-portal'])
  const userData = useSelector(selectUserData)
  const userEmail = userData?.user?.email || ''

  return (
    <Dashboard.Container className="customer-portal">
      <div className="customer-portal__container">
        <iframe
          src={`https://elevateoshub.com?email=${encodeURIComponent(userEmail)}`}
          className="customer-portal__iframe"
          title={t('customer-portal:title')}
          frameBorder="0"
          allowFullScreen
        />
      </div>
    </Dashboard.Container>
  )
}

export default CustomerPortal
